import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EMPTY, iif, of, Subscription } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'wsb-validation-error-msg',
  templateUrl: './validation-error-msg.component.html',
  styleUrls: ['./validation-error-msg.component.scss'],
  standalone: false
})
export class ValidationErrorMsgComponent implements OnInit, OnDestroy {
  @Input() fc: UntypedFormControl;
  @Input() customMsg?: string | null;
  errorMsg: string;
  private errorSubscription: Subscription;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    if (this.fc?.statusChanges) {
      this.errorSubscription = this.fc.statusChanges
        .pipe(
          debounceTime(300),
          map(() => this.printErrorMsg(this.fc.errors)),
          switchMap(translation => iif(() => translation !== EMPTY, translation, of('')))
        )
        .subscribe(msg => (this.errorMsg = msg));
    }
  }

  printErrorMsg(errorObj) {
    if (errorObj === null) {
      return EMPTY;
    }
    if (errorObj.hasOwnProperty('minlength')) {
      return this.translateService.get('error_validation_min_length', { requiredLength: errorObj.minlength.requiredLength });
    }
    if (errorObj.hasOwnProperty('maxlength')) {
      return this.translateService.get('error_validation_max_length', { requiredLength: errorObj.maxlength.requiredLength });
    }
    if (errorObj.hasOwnProperty('maxLengthProvince')) {
      return this.translateService.get(`error_validation_province_max_lenght`);
    }
    if (errorObj.hasOwnProperty('required')) {
      return this.translateService.get(`error_validation_required`);
    }
    if (errorObj.hasOwnProperty('email')) {
      return this.translateService.get(`error_validation_email`);
    }
    if (errorObj.hasOwnProperty('notEquivalent')) {
      return this.translateService.get(`error_validation_password_dont_match`);
    }
    if (errorObj.hasOwnProperty('BadUsername')) {
      return this.translateService.get(`error_validation_username`);
    }
    if (errorObj.hasOwnProperty('priceOverFunds')) {
      return this.translateService.get(`error_validation_price_over_funds`);
    }
    if (errorObj.hasOwnProperty('badSender')) {
      return this.translateService.get(`error_71`);
    }
    if (errorObj.hasOwnProperty('badTimeFormat')) {
      return this.translateService.get(`error_wrongtimeformat`);
    }
    if (errorObj.hasOwnProperty('workinghours')) {
      return this.translateService.get(`validate_workinghours`);
    }
    if (errorObj.hasOwnProperty('BadPassword')) {
      return this.translateService.get(`validate_password`);
    }
    if (errorObj.hasOwnProperty('overMaxDate')) {
      return this.translateService.get(`error_validation_sms_date_schedule`);
    }
    if (errorObj.hasOwnProperty('noWhitespace')) {
      return this.translateService.get(`error_validation_username`);
    }
    if (errorObj.hasOwnProperty('badDynamicField')) {
      return this.translateService.get(`error_validation_dynamic_field`);
    }
    if (errorObj.hasOwnProperty('emailsMustBeEqual')) {
      return this.translateService.get(`error_validation_email_dont_match`);
    }
    if (errorObj.hasOwnProperty('smsAdvScheduledDate')) {
      return this.translateService.get(`smsadv_send_time_wo_info`);
    }
    if (errorObj.hasOwnProperty('fileTooBig')) {
      return this.translateService.get(`error_validation_sms_file_size`);
    }
    if (errorObj.hasOwnProperty('pattern')) {
      return this.customMsg ? this.translateService.get(this.customMsg) : this.translateService.get(`error_validation_pattern`);
    }
    if (errorObj.hasOwnProperty('billingVatCodeLength')) {
      return this.translateService.get(`error_198`);
    }
    return EMPTY;
  }

  ngOnDestroy(): void {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }
}
